import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/modules/shared/toast/toast.service';
import { MarginCalcStoreService } from '../../services/margincalc-store.service';
import { MarginService } from '../../services/margincalc.service';
import { ConfirmationModalMarginComponent } from '../confirmation-modal-margin/confirmation-modal-margin.component';
import { CustomRegExp } from 'src/app/modules/shared/services/regex';
import { GlobalStoreService } from 'src/app/modules/global/services/global-store.service';

@Component({
  selector: 'app-save-modal',
  standalone: false,
  templateUrl: './save-modal.component.html',
  styleUrls: ['./save-modal.component.scss']
})
export class SaveModalComponent implements OnInit {
  gridName : string = '';
  loading : boolean = false;
  isValid: boolean = true;
  constructor(public activeModal: NgbActiveModal, private service: MarginService,private router: Router, 
    public storeService: MarginCalcStoreService, private toastService: ToastService,private modalService: NgbModal,
    public globalStore: GlobalStoreService) {

   }

  ngOnInit(): void {
  }

  SaveMarginCalgulator() {
    if((this.gridName).trim().length === 0) {
      const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.message = 'Please enter valid name';
    }
    else if (!this.gridName.match(new CustomRegExp(this.globalStore.regexValidator,'g'))) {
        this.isValid = false;
        return;
      }
    else {
      this.isValid = true;
      this.loading = true;
      this.storeService.saveMarginData.forEach((data, index) => {
        data.GridName = this.gridName;
      });
      this.service.saveMarginCalculator(0,this.storeService.saveMarginData).subscribe((res) => {
        if(res.Message === 'Success') {
          this.loading = false;
          this.toastService.show('Saved successfully');
          this.activeModal.dismiss('Cross click');
          this.router.navigateByUrl('grid-data');
        }
        else {
          this.loading = false;
          this.toastService.show(res.Message);
        }      
      });
    }    
  }

}
